import { query, mutate } from './../api';
export var CURRENT_USER_QUERY = "\n  {\n    currentUser {\n      id\n    }\n  }\n";

var currentUserAccessor = function currentUserAccessor(_ref) {
  var currentUser = _ref.currentUser;
  return currentUser;
};

export var queryCurrentUser = function queryCurrentUser() {
  return query(CURRENT_USER_QUERY).then(currentUserAccessor);
};
var EVENT_MUTATION = "\n  mutation trackEvents($event: json) {\n    trackEvents(events: $event)\n  }\n";
export var trackSanEvent = function trackSanEvent(event_name, created_at, metadata) {
  return queryCurrentUser().then(function (currentUser) {
    if (!currentUser) return;
    return mutate(EVENT_MUTATION, {
      variables: {
        event: JSON.stringify([{
          event_name: event_name,
          metadata: metadata,
          created_at: created_at.toISOString()
        }])
      }
    });
  });
};